var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.951,
    height: 27.95,
    viewBox: "0 0 27.951 27.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.879,
    y1: 0.847,
    x2: 0.179,
    y2: 0.291,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_12",
    "data-name": "Union 12",
    d: "M19305.74,24.3a3.657,3.657,0,1,1,3.658,3.655A3.665,3.665,0,0,1,19305.74,24.3Zm3.1,0a.555.555,0,1,0,.557-.557A.556.556,0,0,0,19308.842,24.3Zm-15.734,0a3.657,3.657,0,1,1,3.66,3.655A3.665,3.665,0,0,1,19293.107,24.3Zm3.1,0a.556.556,0,1,0,.559-.557A.554.554,0,0,0,19296.209,24.3Zm.412-4.557a3.657,3.657,0,0,1-3.6-2.991l-2.479-13.219a.557.557,0,0,0-.537-.427h-1.459a1.551,1.551,0,0,1,0-3.1h1.459a3.67,3.67,0,0,1,3.572,2.889.2.2,0,0,1,.01.039l.2,1.071h19.6a1.553,1.553,0,0,1,1.531,1.808l-1.812,10.878a3.645,3.645,0,0,1-3.607,3.054Zm-.543-3.563a.556.556,0,0,0,.543.461h12.889a.557.557,0,0,0,.549-.465l1.508-9.065h-17.189Z",
    transform: "translate(-19287)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.cb1a0cb3e49c1dfa352c498f7fc07a07.svg";
export { ForwardRef as ReactComponent };